/* istanbul ignore file */
import { brand, RETURN_RESOLUTIONS, REFUND_METHOD } from 'config';
import { buildKey } from './General';

export const createPayloadFromUopResponse = (
  returnItems,
  returnSelections,
  returnMethod,
  applyConditionalReturnFee = false,
  isRegistryShipment = false,
) => {
  const payload = {};
  payload.orderNumber = returnItems?.orderNumber;
  payload.returnDropOffMethod = returnMethod;
  payload.isMkpOrder = returnItems?.isMkpOrder;
  payload.isRegistryShipment = isRegistryShipment;
  const items = returnItems?.cartonLines ?? [];
  const cartonLines = [];
  items.forEach((item) => {
    returnSelections.returnItems?.forEach((returnItem) => {
      const key = buildKey(item);
      if (returnItem?.key === key) {
        const shippingChargeIndicator = returnItems?.returnReason?.find(
          (reason) => reason?.code === returnItem?.returnReason,
        )?.shippingChargeIndicator;
        const details = {
          upc: item?.upc,
          ...(!returnItems?.isMkpOrder && { fulfillmentStore: item?.fulfillmentStore, fulfillmentChannel: item?.fulfillmentChannel }),
          fulfillmentType: item.fulfillmentType,
          unitPrice: item?.unitPrice,
          taxPerUnit: item?.taxPerUnit,
          returnType: item?.returnType,
          orderLineId: item?.orderLineId,
          returnQuantity: item?.returnType !== 'PR' ? item?.returnQuantity : +returnItem?.quantity,
          returnReason: {
            shippingChargeIndicator: item?.returnType !== 'PR' ? 'N' : shippingChargeIndicator,
          },
          orderLineCharges: item?.orderLineCharges,
          orderLineTaxes: item?.orderLineTaxes,
          protectionPlanPrice: item?.protectionPlanPrice,
          protectionPlanTax: item?.protectionPlanTax,
        };
        cartonLines.push(details);
      }
    });
  });
  const resolutionMap = {
    [REFUND_METHOD.REPLACEMENT]: RETURN_RESOLUTIONS.REPLACEMENT,
    [REFUND_METHOD.EXCHANGE]: RETURN_RESOLUTIONS.EXCHANGE,
  };
  payload.resolutionOptions = resolutionMap[returnSelections.refundOption?.choice] || RETURN_RESOLUTIONS.REFUND;
  payload.cartonLines = cartonLines;
  if (brand === 'mcom') payload.applyConditionalReturnFee = applyConditionalReturnFee;
  return payload;
};
